<div class="row">
  <div class="col">
    <table class="table" *ngIf="!namingState">
      <thead>
      <tr>
        <th>{{ 'nav.campaigns.contentShare' | translate }}</th>

        <th>{{ 'lang.globals.validity' | translate }}</th>
        <th>{{ 'lang.globals.filter' | translate }}</th>
        <th>{{ 'lang.globals.quotas' | translate }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let contentShare of submissions; index as i; last as last">
        <td>
          <span [innerHTML]="(contentShare?.name | truncate : 23)"></span>
        </td>
        <td>
          <sb-comp-validity-range-display [from]="contentShare.validFrom" [till]="contentShare.validTill"></sb-comp-validity-range-display>
        </td>
        <td>
          <sb-comp-filter-overview hideClass="d-xxl" [timeCull]="contentShare?.timeCull" [geoCull]="contentShare?.geoCull"
                                   [stateSpaceCull]="contentShare?.stateSpaceCull" [playerCull]="contentShare?.playerCull">
          </sb-comp-filter-overview>
        </td>
        <td>
          <div class="tw-flex tw-justify-center tw-min-w-[500px]">
            <i *ngIf="!contentShare?.quotas || contentShare?.quotas?.length === 0">{{ 'lang.globals.noQuotas' | translate }}</i>
            <ng-container *ngIf="contentShare?.quotas?.length !== 0">
              <div class="tw-flex tw-w-full tw-gap-2">
                <sb-comp-single-quota *ngFor="let quota of contentShare.quotas" [quota]="quota"
                                      [width]="quota.share"></sb-comp-single-quota>
              </div>
            </ng-container>
          </div>
        </td>
        <td class="tr">
          <button (click)="deleteContentShareFromSubmission(i)" class="btn btn-danger">
            <sb-icon icon="trash"></sb-icon>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <form [formGroup]="form" *ngIf="isInModalContext && editMode && namingState">
      <div class="d-flex justify-content-between align-items-center my-3">
        <div class="form-group">
          <label class="form-label" for="Name">{{ 'lang.globals.name' | translate }}</label>
          <input type="text" id="Name" class="form-control" formControlName="Name">
          <div *ngIf="Name.touched && Name.errors?.required"
               class="alert alert-danger">{{ 'lang.globals.nameWarning' | translate }}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label" for="Description">{{ 'lang.globals.description' | translate }}</label>
          <input type="text" id="Description" class="form-control" formControlName="Description">
        </div>
      </div>
    </form>
    <div class="row" *ngIf="isInModalContext">
      <div
          class="col mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
        <button class="btn btn-secondary"
                (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
        </button>
        <button class="btn btn-primary mr-2" [disabled]="editMode && namingState && form.invalid"
                (click)="ok()">{{ editMode && namingState ? ('lang.globals.submit' | translate) : ('lang.globals.next' | translate) }}
        </button>

      </div>
    </div>
  </div>
</div>
